import { getTvObject, tv } from '@costar-ui/cosmos';
import { baseStyles } from './switch-base.styles.esm.js';

var switchTV = getTvObject({
  base: ['flex', 'flex-shrink-0', 'items-center', 'bg-action-neutral', 'border', 'border-transparent', 'rounded-full', 'h-4', 'w-8', 'transition', 'hover:cursor-pointer', "after:content-['']", 'after:left-[0.125rem]', 'after:h-3', 'after:w-3', 'after:absolute', 'after:rounded-full', 'after:border', 'after:border-transparent', 'after:transition-all', 'after:bg-base'],
  variants: {
    isSelected: {
      "true": ['after:translate-x-full', 'after:bg-base', 'after:left-[0.375rem]', 'bg-action-selected']
    },
    isFocused: {
      "true": ['border-focus', 'border-2']
    },
    isDisabled: {
      "true": ['hover:cursor-not-allowed', 'border-disabled', 'bg-action-disabled', 'after:border-disabled']
    }
  }
});
var base = {
  "switch": tv(switchTV),
  base: baseStyles
};
var switchStyles = {
  base: base
};

export { switchStyles, switchTV };
//# sourceMappingURL=switch.styles.esm.js.map
